import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  title: {
    fontWeight: 500,
    color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
  },
}));

export const Header: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Typography variant="h4" component="h1" className={classes.title}>
      {t('ron:schedule-closing')}
    </Typography>
  );
};
